// extracted by mini-css-extract-plugin
export var attachButton = "_c9-8";
export var sendButton = "_c9-2";
export var sendDisabled = "_c9-4";
export var sendEnabled = "_c9-3";
export var sendIcon = "_c9-6";
export var sendIconDisabled = "_c9-7";
export var sendStreaming = "_c9-5";
export var textarea = "_c9-1";
export var wrapper = "_c9-0";